/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { Flex, Inline, xcss } from '@atlaskit/primitives';
import { NoInstancesSvg } from './no-instances-svg';
var titleStyles = xcss({
  font: 'font.heading.small',
  marginTop: 'space.200'
});
var descriptionStyles = xcss({
  marginTop: 'space.100'
});
var containerStyles = xcss({
  marginTop: 'space.800'
});
export var NoInstancesView = function NoInstancesView(_ref) {
  var title = _ref.title,
    description = _ref.description,
    testId = _ref.testId;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return jsx(Flex, {
    testId: testId,
    direction: "column",
    alignItems: "center",
    xcss: containerStyles
  }, jsx(NoInstancesSvg, null), jsx(Inline, {
    as: "span",
    xcss: titleStyles
  }, formatMessage(title)), jsx(Inline, {
    as: "span",
    xcss: descriptionStyles
  }, formatMessage(description)));
};